import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Button, Form, FormControl, FormGroup, ControlLabel, Row, Col, Modal, HelpBlock } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import InputNumber from 'rc-input-number'
import Select from 'react-select'
import './Stock.css'
import TyreStore from 'stores/TyreStore'
import StockStore from 'stores/StockStore'
import ConfirmPopup from 'component/element/ConfirmPopup'
import CKAutocomplete from 'component/element/CKAutocomplete'
import StockTyreEditCategoryModal from './StockTyreEditCategoryModal'
import WorkdocStore from 'stores/WorkdocStore'
import Moment from 'moment'
var NotificationSystem = require('react-notification-system')
var TODAY = Moment().format('L').replace(Moment().format('YYYY'), (Moment().format('YYYY')*1) + 543)

class StockTyreModal extends Component {

  constructor(props) {
    super(props)

    this.state = this.initState()
  }

  initState() {
    return {
      doc:{barcode:'',request_by:'',response_by:'',added_date:TODAY,description:''},
      customerList:[],
      stockApproverList:[],
      data:[],
      hasError:[],
      messageConfirm:'',
      showConfirm:false,
      optionsCategory:[],
      optionsSubCategory:[{value:'',label:'----- เลือก -----'}],
      catId:'',
      subCatId:'',
      typeId:'',
      showCate:false,
      valid:{request_by:{controlId:null,validationState:null},response_by:{controlId:null,validationState:null},catId:{controlId:null,validationState:null},subCatId:{controlId:null,validationState:null}}
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&newProps.show!==this.props.show) {
        this.setState(this.initState())

        this.loadWorkdocAutocompleteOfficer()
        this.loadWorkdocAutocompleteStockApprover()
        this.loadCategory()
        if (newProps.recordType==='export') {
          let hasError = []
          hasError = newProps.data.map((item,index)=>{
            return false
          })
          this.setState({data:newProps.data,hasError:hasError})
        } else if (newProps.recordType==='import') {
          let hasError = []
          let data = []
          newProps.data.forEach((item,index)=>{
            if (item.quantity<=0) {
              data.push(item)
              hasError.push(false)
            }  
          })
          this.setState({data:data,hasError:hasError})
        }
    }
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {itemnum:'',serial_no:'',tyre_brand:'',tyre_model:'',tyre_size:'',treaddepth:'',begin_used_date:'',retread_count:'',treaddepth_date:'',tyre_mileage:'',in_stock_date:'',vehicle_registration_no:'',quantity:'1',cat_name:'',cat_id:'',subcat_id:'',sub_category:''}
    })
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name
        })
      });
      that.setState({customerList:officer})
    })  
  }  

  loadWorkdocAutocompleteStockApprover() {
    let that = this
    let approver = []
    WorkdocStore.loadWorkdocAutocompleteStockApprover(function(result){
      result.data.forEach(element => {
        approver.push({
          id: element.Value,
          label: element.Name
        })
      });
      that.setState({stockApproverList:approver})
    })  
  }

  loadCategory() {
    let that = this
    let data = [{value:'',label:'----- เลือก -----'}]
    StockStore.loadCategory(this.props.tool,function(result) {
      result.data.forEach(function(item,index) {  
        data.push({
          value: item.cat_id,
          label: item.name
        })
      })
      that.setState({optionsCategory:data})
    })
  }

  loadSubCategory(value) {
    let that = this
    let data = [{label:'----- เลือก -----',value:''}]
    StockStore.loadSubCategory(this.props.tool, value, function (result) {
      result.data.forEach((item,index)=>{
        data.push({
          label:item.name,
          value:item.cat_id
        })
      })  
      that.setState({optionsSubCategory:data})
    })
  }

  onRowAdd(number){
    let {data} = this.state // hasError
    // let {recordType} = this.props
    // if (recordType==='import'||recordType==='add') {
    //   data = data.concat(this.newEmptyRow(number))
    //   hasError.push(false)
    //   this.setState({data:data,hasError:hasError})
    // } else {
    //   this.props.onHide()
    //   this.props.onUpdate(data)
    // }
    this.props.onHide()
    this.props.onUpdate(data)  
  }

  onRowBlankAdd() {
    let {data,hasError} = this.state
    data = data.concat(this.newEmptyRow(1))
    hasError.push(false)
    this.setState({data:data,hasError:hasError})
  }

  onDocChange(key,e) {
    let {doc} = this.state
    doc[key] = e.target.value
    this.setState({doc:doc})
  }

  onDocSelect(key, e) {
    let {doc} = this.state
    doc[key] = e
    this.setState({doc:doc})
  }

  onTextChange(index,field,e) {
    let {data} = this.state
    let value = field==='treaddepth'||field==='tyre_mileage'||field==='retread_count'||field==='begin_used_date'||field==='treaddepth_date'||field==='in_stock_date'?e:e.target.value
    data[index][field] = value
    this.setState({data:data}) 
  }

  onTextKeyPress(index,field,e) {
    let {data} = this.state
    let {recordType} = this.props
    if (e.charCode===13) {
      let value = e.target.value
      StockStore.loadCheckSerialNo(this.props.tool,value,(result)=>{
        if (result.data.length>0) {
          if (result.data[0].quantity>0||recordType==='import') {
            if (recordType==='import'&&result.data[0].quantity>0) {
              this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'รายการนี้มีอยู่ในคลังแล้ว',
                level: 'error',
                position: 'tc'
              });
            } else {
              data[index] = result.data[0]
              data[index].begin_used_date = result.data[0].begin_used_date==='0000-00-00'||result.data[0].begin_used_date===null?'':Moment(result.data[0].begin_used_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
              data[index].treaddepth_date = result.data[0].treaddepth_date==='0000-00-00'||result.data[0].treaddepth_date===null?'':Moment(result.data[0].treaddepth_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
              data[index].in_stock_date = result.data[0].in_stock_date==='0000-00-00'||result.data[0].in_stock_date===null?'':Moment(result.data[0].in_stock_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
              this.setState({data:data})
            }  
          } else {
            this._notificationSystem.addNotification({
              title: 'แจ้งเตือน',
              message: 'รายการนี้ไม่ได้อยู่ในคลัง',
              level: 'error',
              position: 'tc'
            });
          }
        } else {
          this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ไม่พบยางหมายเลข '+value,
            level: 'error',
            position: 'tc'
          });
        }
      })
    }
  }

  onCategorySaveClick() {
    let data = this.refs.categoryPop.getWrappedInstance().getData()
    let that = this
    let {messages} = this.props
    let {typeId,catId} = this.state
    StockStore.saveTyreCategory(this.props.tool, (typeId==='cat_id'?undefined:catId), data, function (result) {
      if (typeId==='cat_id') {
        let optionsCategory = result.data.map((item, index) => {
          return { value: item.cat_id, label: item.name }
        })
        optionsCategory.unshift({value:'',label:'----- เลือก -----'})
        that.setState({ showCate: false, optionsCategory: optionsCategory, typeId:'' })
        // if (that.props.onNewCategory !=== undefined)
        //   that.props.onNewCategory()
      } else if (typeId==='sub_cat_id') {
        let optionsSubCategory = result.data.map((item, index) => {
          return { value: item.cat_id, label: item.name }
        })
        optionsSubCategory.unshift({value:'',label:'----- เลือก -----'})
        that.setState({ showCate: false, optionsSubCategory: optionsSubCategory, typeId:'' })
        // if (that.props.onNewSubCategory !=== undefined)
        //   that.props.onNewSubCategory(dataSet.cat_id)
      }    
    }, function () {
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: messages['Save Category failed, Please Try Again.'],
        level: 'error',
        position: 'tc'
      });
    })
  }

  onNewCategory(cat_id) {
    let {optionsCategory} = this.state
    let key = optionsCategory.findIndex(x=>x.value===cat_id)
    if (key!==-1) {
      optionsCategory.splice(key,1)
      this.setState({optionsCategory:optionsCategory})
      if (this.props.dataSet.cat_id===cat_id)
        this.props.onCatChange('')
    }
    this.props.onNewCategory(cat_id)
  }

  onNewSubCategory(cat_id) {
    let {optionsSubCategory,sub_cat_id} = this.state
    let key = optionsSubCategory.findIndex(x=>x.value===cat_id)
    if (key!==-1) {
      optionsSubCategory.splice(key,1)
      this.setState({optionsSubCategory:optionsSubCategory})
      if (sub_cat_id===cat_id)
        this.setState({sub_cat_id:''})
    }
    this.props.onNewSubCategory(cat_id)
  }

  onCateAddClick(txt) {
      this.setState({typeId:txt})
      setTimeout(()=>{
        this.setState({showCate:true})
      },100)
  }

  onCategoryChange(e) {
    let {catId,optionsCategory,data} = this.state
    catId = e.value
    if (catId==='') {
      data = data.map((item,index)=>{
        item.category = ''
        item.cat_name = ''
        item.cat_id = ''
        return item
      })
    } else {
      let key = optionsCategory.findIndex(x=>x.value===catId)
      if (key!==-1) {
        data = data.map((item,index)=>{
          item.category = catId
          item.cat_name = optionsCategory[key].label
          item.cat_id = catId
          return item
        })
      }
    }  

    this.setState({catId:catId,subCatId:'',data:data})
    this.loadSubCategory(e.value)
  }

  onSubCategoryChange(e) {
    let {subCatId,optionsSubCategory,data} = this.state
    subCatId = e.value
    if (subCatId==='') {
      data = data.map((item,index)=>{
        item.sub_category = ''
        item.subcat_id = ''
        item.subcat_name = ''
        return item
      })
    } else {
      let key = optionsSubCategory.findIndex(x=>x.value===subCatId)
      if (key!==-1) {
        data = data.map((item,index)=>{
          item.sub_category = subCatId
          item.subcat_id = subCatId
          item.subcat_name = optionsSubCategory[key].label
          return item
        })
      }
    }

    this.setState({subCatId:subCatId,data:data})
  }

  onDelClick(index) {
    let {data,hasError} = this.state
    data.splice(index,1)
    hasError.splice(index,1)
    this.setState({data:data,hasError:hasError})
  }

  onConfirmSaveClick() {
    let {doc,catId,subCatId,valid,data,optionsCategory,optionsSubCategory} = this.state
    let {messages,recordType,tool} = this.props
    doc = Object.assign({cat_id:catId,sub_cat_id:subCatId,stock_type:tool,record_type:recordType},doc)
    let catKey = optionsCategory.findIndex(x=>x.value===catId)
    if (catKey!==-1) {
      data = data.map((item,index)=>{
        item.category = catId
        item.cat_name = catId===''?'':optionsCategory[catKey].label
        item.cat_id = catId
        return item
      })
    }
    let subCatKey = optionsSubCategory.findIndex(x=>x.value===subCatId)
    if (subCatKey!==-1) {
      data = data.map((item,index)=>{
        item.sub_category = subCatId
        item.subcat_id = subCatId
        item.subcat_name = subCatId===''?'':optionsSubCategory[subCatKey].label
        return item
      })
    }
    this.setState({data:data})

    if (recordType==='import'||recordType==='add') {
      let postData = {meta:doc,items:data}
      TyreStore.saveImportStockTyre(this.props.tool,postData,(result)=>{
        if (result.status==='OK') {
          this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'บันทึกรายการสำเร็จ',
            level: 'info',
            position: 'tc'
          });
          valid = {request_by:{controlId:null,validationState:null},response_by:{controlId:null,validationState:null},catId:{controlId:null,validationState:null},subCatId:{controlId:null,validationState:null}}
          this.setState({showConfirm:false,valid:valid,doc:{barcode:'',request_by:'',response_by:'',added_date:TODAY,description:''}})
          setTimeout(()=>{
            this.props.onHide()
            this.props.onReload()
            this.props.onCancel()
          },1000)
        }
      },()=>{
        this._notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: messages['Save Category failed, Please Try Again.'],
          level: 'error',
          position: 'tc'
        });
        valid = {request_by:{controlId:null,validationState:null},response_by:{controlId:null,validationState:null},catId:{controlId:null,validationState:null},subCatId:{controlId:null,validationState:null}}
        this.setState({showConfirm:false,valid:valid,doc:{barcode:'',request_by:'',response_by:'',added_date:TODAY,description:''}})
        setTimeout(()=>{
          this.props.onHide()
          this.props.onReload()
          this.props.onCancel()
        },1000)
      })
    } else if (recordType==='export') {
      let postData = {meta:doc,item:data}
      StockStore.exportProduct(this.props.tool,postData,(result)=>{
        if (result.status === 'OK') {
          if (process.env.NODE_ENV === "development") {
            window.open('https://demo-fast.bigfix.co/sriracha/pdf/?sr='+result.id+'&file=stockrecord_doc', '_blank');
          } else{
            window.open('./pdf/?sr='+result.id+'&file=stockrecord_doc', '_blank');
          }
        }
        valid = {request_by:{controlId:null,validationState:null},response_by:{controlId:null,validationState:null},catId:{controlId:null,validationState:null},subCatId:{controlId:null,validationState:null}}
        this.setState({showConfirm:false,valid:valid,doc:{barcode:'',request_by:'',response_by:'',added_date:TODAY,description:''}})
        setTimeout(()=>{
          this.props.onHide()
          this.props.onReload()
          this.props.onCancel()
        },1000)
      })
    }
  }

  onSaveClick() {
    let {doc,catId,subCatId,valid,data} = this.state
    let {messages,recordType} = this.props
    valid = {request_by:{controlId:null,validationState:null},response_by:{controlId:null,validationState:null},catId:{controlId:null,validationState:null},subCatId:{controlId:null,validationState:null}}
    this.setState({valid:valid})

    if (doc.request_by==='') {
        valid.request_by.controlId = 'formValidationError1'
        valid.request_by.validationState = 'error'
        this.setState({valid:valid})
        return false
    }
    if (doc.response_by==='') {
        valid.response_by.controlId = 'formValidationError1'
        valid.response_by.validationState = 'error'
        this.setState({valid:valid})
        return false
    }
    if (recordType==='add') {
      if (catId==='') {
          valid.catId.controlId = 'formValidationError1'
          valid.catId.validationState = 'error'
          this.setState({valid:valid})
          return false
      }
      if (subCatId==='') {
          valid.subCatId.controlId = 'formValidationError1'
          valid.subCatId.validationState = 'error'
          this.setState({valid:valid})
          return false
      }
    }  

    if (data.length===0) {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'กรุณาเพิ่มรายการที่ต้องการ'+this.props.title,
        level: 'error',
        position: 'tc'
      });
      return false 
    }

    let hasError = []
    let isValid = false
    hasError = data.map((item,index)=>{
      if (item.serial_no==='') {
        isValid = true
        return true
      } else {
        return false  
      }  
    })
    this.setState({hasError:hasError})
    if (isValid) {
      return false
    } 
    this.setState({showConfirm:true, messageConfirm:messages['Want To Save This Item']})  
  }

  renderTable() {
    let {recordType} = this.props
    return(
      <div className='table-responsive'>
        <table className="table table-hover table-bordered-solid" style={{minWidth:(recordType==='export'?'1280px':'1800px')}}>
          <thead>
            <tr>
                <th style={{width:'20px'}} className="text-center">ลำดับ</th>
                <th style={{width:'100px'}} className="text-center">หมายเลขยาง</th>
                <th style={{width:'90px'}} className="text-center">ยี่ห้อ</th>
                <th style={{width:'90px'}} className="text-center">รุ่น</th>
                <th style={{width:'90px'}} className="text-center">ขนาดยาง</th>
                {recordType==='export'?'':<th style={{width:'120px'}} className="text-center">วันที่เริ่มใช้ยาง</th>}
                {recordType==='export'?'':<th style={{width:'90px'}} className="text-center">จำนวนครั้งที่<br />หล่อดอก</th>}
                {recordType==='export'?'':<th style={{width:'90px'}} className="text-center">ความลึกดอกยาง<br/>วัดครั้งสุดท้าย (มม.)</th>}
                {recordType==='export'?'':<th style={{width:'120px'}} className="text-center">วันที่วัดดอกยาง</th>}
                <th style={{width:'90px'}} className="text-center">จำนวน กม.</th>
                {recordType==='export'?'':<th style={{width:'110px'}} className="text-center">ทะเบียนรถที่<br/>ใช้ยางครั้งสุดท้าย</th>}
                {recordType==='export'?'':<th style={{width:'120px'}} className="text-center">วันที่<br/>ถอดไว้ที่คลัง</th>}
                <th style={{width:'20px'}} className="text-center">ลบ ?</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>  
    )
  }

  renderRowData() {
    let {data,hasError} = this.state
    let {recordType} = this.props
    if (data.length===0) {
      return (<tr><td colSpan={recordType==='export'?7:13}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index}>
                <td className="text-center">{index+1}</td>
                <td className="text-center">
                    <FormControl 
                      style={{borderColor:(hasError[index]?'#dd4b39':'')}} 
                      disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false} 
                      value={item.serial_no} 
                      onChange={this.onTextChange.bind(this,index,'serial_no')} 
                      onKeyPress={this.onTextKeyPress.bind(this,index,'serial_no')}
                    />
                </td>  
                <td className="text-center">
                    <FormControl disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false} value={item.tyre_brand} onChange={this.onTextChange.bind(this,index,'tyre_brand')} />
                </td>
                <td className="text-center">
                    <FormControl disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false} value={item.tyre_model} onChange={this.onTextChange.bind(this,index,'tyre_model')} />
                </td>  
                <td className="text-center">
                    <FormControl disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false} value={item.tyre_size} onChange={this.onTextChange.bind(this,index,'tyre_size')} />
                </td>  
                {recordType==='export'?'':
                <td className="text-center">
                    <DatePicker
                        maxWidth={'100%'}
                        showIcon={true}
                        showFooter={true}
                        popPlacement='top'
                        buddhistEra
                        value={item.begin_used_date}
                        onChange={this.onTextChange.bind(this,index,'begin_used_date')}
                        disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false}
                    />
                </td>  
                }
                {recordType==='export'?'':
                <td className="text-center">
                    <InputNumber
                        className='input-number-format-form-control text-center'
                        value={item.retread_count} 
                        onChange={this.onTextChange.bind(this,index,'retread_count')}
                        formatter={value =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                        disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false}
                    />
                </td>  
                }
                {recordType==='export'?'':
                <td className="text-center">
                    <InputNumber
                        className='input-number-format-form-control text-center'
                        value={item.treaddepth} 
                        onChange={this.onTextChange.bind(this,index,'treaddepth')}
                        formatter={value =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                        disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false}
                    />
                </td>  
                }
                {recordType==='export'?'':
                <td className="text-center">
                    <DatePicker
                        maxWidth={'100%'}
                        showIcon={true}
                        showFooter={true}
                        popPlacement='top'
                        buddhistEra
                        value={item.treaddepth_date}
                        onChange={this.onTextChange.bind(this,index,'treaddepth_date')}
                        disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false}
                    />
                </td>  
                }
                <td className="text-center">
                    <InputNumber
                        className='input-number-format-form-control text-center'
                        value={item.tyre_mileage} 
                        onChange={this.onTextChange.bind(this,index,'tyre_mileage')}
                        formatter={value =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                        disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false}
                    />
                </td>  
                {recordType==='export'?'':
                <td className="text-center">
                    <FormControl disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false} value={item.vehicle_registration_no} onChange={this.onTextChange.bind(this,index,'vehicle_registration_no')} />
                </td> 
                }
                {recordType==='export'?'':
                <td className="text-center">
                    <DatePicker
                        maxWidth={'100%'}
                        showIcon={true}
                        showFooter={true}
                        popPlacement='top'
                        buddhistEra
                        value={item.in_stock_date}
                        onChange={this.onTextChange.bind(this,index,'in_stock_date')}
                        disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false}
                    />
                </td> 
                }   
                <td className='text-center'>
                  <Button disabled={recordType==='export'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?true:false} bsStyle='danger' onClick={this.onDelClick.bind(this,index)}><FontAwesome name='eraser' /></Button>
                </td>
            </tr>  
          ) 
        })
      )
    }  
  }

  render(){
    let {messages,show,title,recordType} = this.props
    let {optionsCategory,optionsSubCategory,catId,subCatId,typeId,showCate,valid} = this.state
    return (
      <div>
        <Modal bsSize="large" show={show} onHide={this.props.onHide} dialogClassName="fullwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>
                {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Document Number']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl onChange={()=>{}} type="text" placeholder={'<'+messages['Auto Generated Number']+'>'} className="input-dark" disabled={true} />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Date']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl onChange={()=>{}} type="text" placeholder="" className="input-dark" value={this.state.doc.added_date} disabled={true} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={valid.request_by.controlId}
                    validationState={valid.request_by.validationState}
                  >
                    <ControlLabel>{messages['RequesterOut']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={valid.request_by.controlId}
                    validationState={valid.request_by.validationState}
                  >
                    <CKAutocomplete
                        top={'-34px'}
                        items={this.state.customerList}
                        value={this.state.doc.request_by}
                        onChange={this.onDocChange.bind(this,'request_by')}
                        onSelect={this.onDocSelect.bind(this,'request_by')}
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup
                    controlId={valid.response_by.controlId}
                    validationState={valid.response_by.validationState}
                  >
                    <ControlLabel>{messages['Approvers']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={valid.response_by.controlId}
                    validationState={valid.response_by.validationState}
                  >
                    <CKAutocomplete
                      top={'-34px'}
                      items={this.state.stockApproverList}
                      value={this.state.doc.response_by}
                      onChange={this.onDocChange.bind(this,'response_by')}
                      onSelect={this.onDocSelect.bind(this,'response_by')}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {recordType==='add'?
              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={valid.catId.controlId}
                    validationState={valid.catId.validationState}
                  >
                    <ControlLabel>หมวดหมู่<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={valid.catId.controlId}
                    validationState={valid.catId.validationState}
                  >
                    <Select
                        // className='zIndex-1'
                        clearable={false}
                        name="form-field-name"
                        placeholder='เลือกหมวดหมู่'
                        value={catId}
                        options={optionsCategory}
                        onChange={this.onCategoryChange.bind(this)}
                    />
                    <FormControl.Feedback />
                    <HelpBlock>
                        <Button
                            bsStyle={'link'}
                            onClick={this.onCateAddClick.bind(this,'cat_id')}
                        >
                            <FontAwesome name='plus' /> เพิ่มหมวดหมู่
                        </Button>
                    </HelpBlock>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup
                    controlId={valid.subCatId.controlId}
                    validationState={valid.subCatId.validationState}
                  >
                    <ControlLabel>หมวดหมู่ย่อย<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={valid.subCatId.controlId}
                    validationState={valid.subCatId.validationState}
                  >
                    <Select
                        // className='zIndex-1'
                        clearable={false}
                        name="form-field-name"
                        placeholder='เลือกหมวดหมู่ย่อย'
                        value={subCatId}
                        options={optionsSubCategory}
                        onChange={this.onSubCategoryChange.bind(this)}
                    />
                    <FormControl.Feedback />
                    <HelpBlock>
                        <Button
                            bsStyle={'link'}
                            onClick={this.onCateAddClick.bind(this,'sub_cat_id')}
                        >
                            <FontAwesome name='plus' /> เพิ่มหมวดหมู่ย่อย
                        </Button>
                    </HelpBlock>
                  </FormGroup>
                </Col>
              </Row>
              :''}
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Description']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={10}>
                  <FormGroup>
                    <FormControl 
                        type="text" 
                        placeholder="" 
                        value={this.state.doc.description} 
                        onChange={this.onDocChange.bind(this,'description')} 
                    />
                  </FormGroup>
                </Col>
              </Row>
              {this.renderTable()}
            </Form>      
          </Modal.Body>  
          <Modal.Footer>
            <Button className="btn bg-olive" onClick={this.onRowBlankAdd.bind(this,1)}>
              <FontAwesome name='plus' /> เพิ่มแถว
            </Button>
            <Button className="btn-success" onClick={this.onRowAdd.bind(this,1)}>
              <FontAwesome name='plus' /> {messages['Add Item']}
            </Button>
            <Button className='btn-primary' onClick={this.onSaveClick.bind(this)}>
              <FontAwesome name='save' /> {messages['Save']}
            </Button>
            <Button className="btn-default" onClick={this.props.onHide}>
              <FontAwesome name='close' /> ปิด
            </Button>            
          </Modal.Footer>      
        </Modal>
        <ConfirmPopup
          show={this.state.showConfirm}
          message={this.state.messageConfirm}
          onConfirm={this.onConfirmSaveClick.bind(this)}
          onHide={()=>{this.setState({showConfirm:false})}}
        />
        <StockTyreEditCategoryModal
          show={showCate}
          onHide={()=>{this.setState({showCate:false,typeId:''})}}
          ref='categoryPop'
          catId={catId}
          cateAdd={typeId}
          stockType={this.props.tool}
          onNewCategory={this.onNewCategory.bind(this)}
          onNewSubCategory={this.onNewSubCategory.bind(this)}
          onCategorySaveClick={this.onCategorySaveClick.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }
}

export default StockTyreModal = connect(
  (state) => ({messages: state.message.view.tyre.stock.StockTyreModal}),null,null,{withRef:true}
)(StockTyreModal);




// WEBPACK FOOTER //
// ./src/view/tyre/stock/StockTyreModal.js